import { LitElement } from 'lit';
import Toast from '../utils/toast';

export class ShowToast extends LitElement {
  connectedCallback(): void {
    super.connectedCallback();
    const content = this.dataset.content || '';
    const variant = this.dataset.variant || 'info';

    requestAnimationFrame(() => {
      Toast.show(content, variant as 'info' | 'success' | 'warning' | 'error');
      this.remove();
    });
  }
}

customElements.define('show-toast', ShowToast);
